import { type ExternalProvider } from '@ethersproject/providers';

export interface ExtendedExternalProvider extends ExternalProvider {
  on?: (event: string, callback: (...args: any[]) => void) => void;
  off?: (event: string, callback: (...args: any[]) => void) => void;
  removeListener?: (event: string, callback: (...args: any[]) => void) => void;
  providers?: ExtendedExternalProvider[];
  selectedAddress?: string | null;
  chainId?: string;
  isConnected?: () => boolean;
}

export interface EIP6963ProviderInfo {
  uuid: string;
  name: string;
  icon: string;
  rdns: string;
}

export interface EIP6963ProviderDetail {
  info: EIP6963ProviderInfo;
  provider: ExtendedExternalProvider;
}

export interface EIP6963AnnounceProviderEvent extends CustomEvent {
  detail: {
    info: EIP6963ProviderInfo;
    provider: ExtendedExternalProvider;
  };
}

let providers: EIP6963ProviderDetail[] = [];

export const getProviders = () => providers;

const onAnnounceProvider = (event: EIP6963AnnounceProviderEvent) => {
  const detail = event.detail;
  if (providers.some((p) => p.info.uuid === detail.info.uuid)) return;

  providers = [...providers, detail];
};

export const initProviderDiscovery = () => {
  window.addEventListener(
    'eip6963:announceProvider',
    onAnnounceProvider as EventListener,
  );
  window.dispatchEvent(new Event('eip6963:requestProvider'));

  return () => {
    window.removeEventListener(
      'eip6963:announceProvider',
      onAnnounceProvider as EventListener,
    );
  };
};
